import { render, staticRenderFns } from "./provider__form.vue?vue&type=template&id=3a389b7b"
import script from "./provider__form.vue?vue&type=script&lang=js"
export * from "./provider__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports